<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p>
        <span class="breadcrumb-item" @click="$router.push('/dashboard')">Inicio</span>
        &rsaquo; Registro de Movimientos
      </p>
    </div>
  </div>

  <div class="px-4 container-fluid">

    <!-- ═══ TAB BAR ═══ -->
    <div class="tabs-bar mb-4">
      <button class="tab-btn" :class="{ 'tab-btn--activo': tabActiva === 'sistema' }" @click="cambiarTab('sistema')">
        <span class="tab-icon">🖥</span> Sistema
      </button>
      <button class="tab-btn" :class="{ 'tab-btn--activo': tabActiva === 'basico' }" @click="cambiarTab('basico')">
        <span class="tab-icon">🤖</span> Bot Básico
      </button>
      <button class="tab-btn" :class="{ 'tab-btn--activo': tabActiva === 'premium' }" @click="cambiarTab('premium')">
        <span class="tab-icon">⭐</span> Bot Premium
      </button>
    </div>

    <!-- ══════════════════════════════════════════════
         TAB 1: SISTEMA (auditoría del panel)
    ══════════════════════════════════════════════ -->
    <template v-if="tabActiva === 'sistema'">

      <div class="row">
        <div class="col-12">
          <div class="card ficha-buscador mb-4">
            <div class="titulo">
              <h5 class="mx-4 mt-5 mb-1">Registro de Movimientos</h5>
              <p class="mx-4 mb-3 text-sm opacity-7">Auditoría de todas las acciones realizadas en el panel de administración.</p>
            </div>
            <div class="filtros-grid px-4 pb-4">
              <div class="filtro-item filtro-q">
                <label class="filtro-label">Buscar</label>
                <input v-model="sis.filtros.q" type="text" class="form-control form-control-sm" placeholder="Usuario, descripción, IP..." @keyup.enter="sisCargar(1)" />
              </div>
              <div class="filtro-item">
                <label class="filtro-label">Módulo</label>
                <select v-model="sis.filtros.modulo" class="form-control form-control-sm" @change="sisCargar(1)">
                  <option value="">Todos</option>
                  <option v-for="m in sis.modulos" :key="m" :value="m">{{ m }}</option>
                </select>
              </div>
              <div class="filtro-item">
                <label class="filtro-label">Acción</label>
                <select v-model="sis.filtros.accion" class="form-control form-control-sm" @change="sisCargar(1)">
                  <option value="">Todas</option>
                  <option v-for="a in sis.acciones" :key="a" :value="a">{{ a }}</option>
                </select>
              </div>
              <div class="filtro-item">
                <label class="filtro-label">Desde</label>
                <input v-model="sis.filtros.desde" type="date" class="form-control form-control-sm" @change="sisCargar(1)" />
              </div>
              <div class="filtro-item">
                <label class="filtro-label">Hasta</label>
                <input v-model="sis.filtros.hasta" type="date" class="form-control form-control-sm" @change="sisCargar(1)" />
              </div>
              <div class="filtro-item filtro-btns">
                <QBtn variant="tipster" :label="sis.loading ? 'Cargando...' : 'Aplicar'" :loading="sis.loading" :disabled="sis.loading" @click="sisCargar(1)" />
                <QBtn variant="neutro" label="Limpiar" @click="sisLimpiar" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card ficha-listado">
            <div class="px-4 py-3 card-body">
              <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                <p class="text-sm mb-0 opacity-7">
                  <span v-if="!sis.loading">{{ sis.total.toLocaleString('es-ES') }} registro{{ sis.total !== 1 ? 's' : '' }}</span>
                  <span v-else>Cargando...</span>
                </p>
                <div class="d-flex align-items-center gap-2">
                  <label class="text-xs opacity-7 mb-0">Por página:</label>
                  <select v-model="sis.filtros.porPagina" class="form-control form-control-sm" style="width:70px" @change="sisCargar(1)">
                    <option :value="25">25</option><option :value="50">50</option>
                    <option :value="100">100</option><option :value="200">200</option>
                  </select>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-empirulada">
                  <thead class="thead-light">
                    <tr>
                      <th class="col-fecha th-sort" @click="sisOrdenar('created_at')">Fecha / Hora <span class="sort-icon">{{ sisSortIcon('created_at') }}</span></th>
                      <th class="th-sort" @click="sisOrdenar('usuario_nombre')">Usuario <span class="sort-icon">{{ sisSortIcon('usuario_nombre') }}</span></th>
                      <th class="th-sort" @click="sisOrdenar('modulo')">Módulo <span class="sort-icon">{{ sisSortIcon('modulo') }}</span></th>
                      <th class="th-sort" @click="sisOrdenar('accion')">Acción <span class="sort-icon">{{ sisSortIcon('accion') }}</span></th>
                      <th>Descripción</th>
                      <th class="th-sort" @click="sisOrdenar('entidad_tipo')">Entidad <span class="sort-icon">{{ sisSortIcon('entidad_tipo') }}</span></th>
                      <th>IP</th>
                    </tr>
                  </thead>
                  <tbody class="text-sm">
                    <tr v-if="sis.loading"><td colspan="7" class="text-center py-4 opacity-6"><div class="spinner-border spinner-border-sm text-primary me-2"></div>Cargando...</td></tr>
                    <tr v-else-if="sis.items.length === 0"><td colspan="7" class="text-center py-5 opacity-6">No se encontraron movimientos.</td></tr>
                    <tr v-for="item in sis.items" :key="item.id">
                      <td class="col-fecha">
                        <div class="fecha-bloque">
                          <span class="fecha-dia">{{ fmtFecha(item.created_at) }}</span>
                          <span class="fecha-hora">{{ fmtHora(item.created_at) }}</span>
                        </div>
                      </td>
                      <td>
                        <div class="usuario-bloque">
                          <span class="usuario-avatar">{{ iniciales(item.usuario_nombre) }}</span>
                          <span>{{ item.usuario_nombre || '—' }}</span>
                        </div>
                      </td>
                      <td><span class="badge-modulo" :class="claseModulo(item.modulo)">{{ item.modulo }}</span></td>
                      <td><span class="badge-accion" :class="claseAccion(item.accion)">{{ item.accion }}</span></td>
                      <td class="col-descripcion"><span :title="item.descripcion">{{ item.descripcion || '—' }}</span></td>
                      <td>
                        <span v-if="item.entidad_tipo" class="entidad-chip">
                          {{ item.entidad_tipo }}<span v-if="item.entidad_id" class="entidad-id">#{{ item.entidad_id }}</span>
                        </span>
                        <span v-else class="opacity-5">—</span>
                      </td>
                      <td class="col-ip"><span class="ip-text" :title="item.user_agent">{{ item.ip || '—' }}</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="sis.paginas > 1" class="paginacion mt-3">
                <button class="pag-btn" :disabled="sis.pagina <= 1" @click="sisCargar(sis.pagina - 1)">‹ Anterior</button>
                <template v-for="p in sisPaginasVisibles" :key="p">
                  <span v-if="p === '...'" class="pag-dots">…</span>
                  <button v-else class="pag-btn" :class="{ 'pag-btn--activo': p === sis.pagina }" @click="sisCargar(p)">{{ p }}</button>
                </template>
                <button class="pag-btn" :disabled="sis.pagina >= sis.paginas" @click="sisCargar(sis.pagina + 1)">Siguiente ›</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- ══════════════════════════════════════════════
         TAB 2: BOT BÁSICO (tabla bot_movimiento)
    ══════════════════════════════════════════════ -->
    <template v-if="tabActiva === 'basico'">

      <div class="row">
        <div class="col-12">
          <div class="card ficha-buscador mb-4">
            <div class="titulo">
              <h5 class="mx-4 mt-5 mb-1">Movimientos Bot Básico</h5>
              <p class="mx-4 mb-3 text-sm opacity-7">Historial de todos los eventos del bot de Telegram: accesos, solicitudes, inicializaciones de canal y mensajes.</p>
            </div>
            <div class="filtros-grid px-4 pb-4">
              <div class="filtro-item filtro-q">
                <label class="filtro-label">Buscar en extra</label>
                <input v-model="bot.filtros.q" type="text" class="form-control form-control-sm" placeholder="Nombre, telegram_id, invite link..." @keyup.enter="botCargar(1)" />
              </div>
              <div class="filtro-item">
                <label class="filtro-label">Canal</label>
                <select v-model="bot.filtros.canal_id" class="form-control form-control-sm" @change="botCargar(1)">
                  <option value="">Todos</option>
                  <option v-for="c in bot.canales" :key="c.id" :value="c.id">{{ c.nombre }}</option>
                </select>
              </div>
              <div class="filtro-item">
                <label class="filtro-label">Acción</label>
                <select v-model="bot.filtros.accion" class="form-control form-control-sm" @change="botCargar(1)">
                  <option value="">Todas</option>
                  <option value="A">A — Aprobado</option>
                  <option value="F">F — Solicitud libre</option>
                  <option value="D">D — Denegado</option>
                  <option value="I">I — Init canal</option>
                  <option value="T">T — Texto</option>
                  <option value="B">B — Grupo</option>
                </select>
              </div>
              <div class="filtro-item">
                <label class="filtro-label">Desde</label>
                <input v-model="bot.filtros.desde" type="date" class="form-control form-control-sm" @change="botCargar(1)" />
              </div>
              <div class="filtro-item">
                <label class="filtro-label">Hasta</label>
                <input v-model="bot.filtros.hasta" type="date" class="form-control form-control-sm" @change="botCargar(1)" />
              </div>
              <div class="filtro-item filtro-btns">
                <QBtn variant="tipster" :label="bot.loading ? 'Cargando...' : 'Aplicar'" :loading="bot.loading" :disabled="bot.loading" @click="botCargar(1)" />
                <QBtn variant="neutro" label="Limpiar" @click="botLimpiar" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card ficha-listado">
            <div class="px-4 py-3 card-body">
              <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                <p class="text-sm mb-0 opacity-7">
                  <span v-if="!bot.loading">{{ bot.total.toLocaleString('es-ES') }} evento{{ bot.total !== 1 ? 's' : '' }}</span>
                  <span v-else>Cargando...</span>
                </p>
                <div class="d-flex align-items-center gap-2">
                  <label class="text-xs opacity-7 mb-0">Por página:</label>
                  <select v-model="bot.filtros.porPagina" class="form-control form-control-sm" style="width:70px" @change="botCargar(1)">
                    <option :value="25">25</option><option :value="50">50</option>
                    <option :value="100">100</option><option :value="200">200</option>
                  </select>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-empirulada">
                  <thead class="thead-light">
                    <tr>
                      <th class="col-fecha th-sort" @click="botOrdenar('fecha')">Fecha <span class="sort-icon">{{ botSortIcon('fecha') }}</span></th>
                      <th>Canal</th>
                      <th class="th-sort" @click="botOrdenar('accion')">Acción <span class="sort-icon">{{ botSortIcon('accion') }}</span></th>
                      <th>Telegram ID</th>
                      <th>Nombre</th>
                      <th>Detalle</th>
                    </tr>
                  </thead>
                  <tbody class="text-sm">
                    <tr v-if="bot.loading"><td colspan="6" class="text-center py-4 opacity-6"><div class="spinner-border spinner-border-sm text-primary me-2"></div>Cargando...</td></tr>
                    <tr v-else-if="bot.error"><td colspan="6" class="text-center py-4" style="color:var(--q-red)">{{ bot.error }}</td></tr>
                    <tr v-else-if="bot.items.length === 0"><td colspan="6" class="text-center py-5 opacity-6">No se encontraron eventos.</td></tr>
                    <tr v-for="item in bot.items" :key="item.id">
                      <td class="col-fecha">
                        <div class="fecha-bloque">
                          <span class="fecha-dia">{{ fmtFecha(item.fecha) }}</span>
                          <span class="fecha-hora">{{ fmtHora(item.fecha) }}</span>
                        </div>
                      </td>
                      <td>
                        <span class="entidad-chip">{{ item.canal_nombre }}</span>
                      </td>
                      <td>
                        <span class="badge-accion" :class="claseAccionBot(item.accion)" :title="descripcionAccionBot(item.accion)">
                          {{ item.accion }}
                        </span>
                      </td>
                      <td class="col-ip">
                        <span class="font-mono">{{ parsedExtra(item).telegramId || '—' }}</span>
                      </td>
                      <td>{{ parsedExtra(item).nombre || '—' }}</td>
                      <td class="col-descripcion">
                        <span :title="item.extra">{{ resumenExtra(item) }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="bot.paginas > 1" class="paginacion mt-3">
                <button class="pag-btn" :disabled="bot.pagina <= 1" @click="botCargar(bot.pagina - 1)">‹ Anterior</button>
                <template v-for="p in botPaginasVisibles" :key="p">
                  <span v-if="p === '...'" class="pag-dots">…</span>
                  <button v-else class="pag-btn" :class="{ 'pag-btn--activo': p === bot.pagina }" @click="botCargar(p)">{{ p }}</button>
                </template>
                <button class="pag-btn" :disabled="bot.pagina >= bot.paginas" @click="botCargar(bot.pagina + 1)">Siguiente ›</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- ══════════════════════════════════════════════
         TAB 3: BOT PREMIUM
    ══════════════════════════════════════════════ -->
    <template v-if="tabActiva === 'premium'">

      <!-- Estadísticas rápidas -->
      <div class="stats-row mb-4">
        <div class="stat-card">
          <span class="stat-num">{{ prem.accesos.length }}</span>
          <span class="stat-label">Tipsters vinculados</span>
        </div>
        <div class="stat-card">
          <span class="stat-num">{{ prem.sesiones.length }}</span>
          <span class="stat-label">Sesiones activas</span>
        </div>
        <div class="stat-card">
          <span class="stat-num">{{ prem.canales.length }}</span>
          <span class="stat-label">Canales premium</span>
        </div>
        <div class="stat-card">
          <span class="stat-num">{{ prem.links.filter(l => l.estado === 'pendiente').length }}</span>
          <span class="stat-label">Links pendientes</span>
        </div>
      </div>

      <!-- ── LOG TDLIB ── -->
      <div class="card prem-section mb-4">
        <div class="prem-section-header" @click="toggleSection('log')">
          <div class="d-flex align-items-center gap-2">
            <span class="prem-icon">📋</span>
            <span class="prem-title">Log TDLib</span>
            <span v-if="log.totalKb" class="text-xs opacity-6">({{ log.totalKb }} KB en disco)</span>
          </div>
          <div class="d-flex align-items-center gap-2">
            <select v-if="sections.log" v-model="log.nLineas" class="form-control form-control-sm" style="width:100px" @change.stop="cargarLog()" @click.stop>
              <option :value="100">100 líneas</option>
              <option :value="200">200 líneas</option>
              <option :value="500">500 líneas</option>
              <option :value="1000">1000 líneas</option>
            </select>
            <QBtn v-if="sections.log" variant="neutro" label="↻ Actualizar" @click.stop="cargarLog()" style="padding:4px 12px;font-size:12px;" />
            <span class="toggle-icon">{{ sections.log ? '▲' : '▼' }}</span>
          </div>
        </div>
        <div v-if="sections.log" class="log-viewer">
          <div v-if="log.loading" class="text-center py-4 opacity-6">
            <div class="spinner-border spinner-border-sm text-primary me-2"></div>Cargando log...
          </div>
          <div v-else-if="!log.existe" class="text-center py-4 opacity-6">El archivo tdlib.log no existe.</div>
          <div v-else-if="log.lineas.length === 0" class="text-center py-4 opacity-6">El log está vacío.</div>
          <template v-else>
            <div
              v-for="(linea, idx) in log.lineas"
              :key="idx"
              class="log-linea"
              :class="claseNivelLog(linea.nivel)"
            >
              <span v-if="linea.ts" class="log-ts">{{ linea.ts }}</span>
              <span class="log-nivel" :class="'log-nivel--' + linea.nivel.toLowerCase()">{{ linea.nivel }}</span>
              <span class="log-msg">{{ linea.mensaje }}</span>
            </div>
          </template>
        </div>
      </div>

      <!-- ── ACCESOS TIPSTERS ── -->
      <div class="card prem-section mb-4">
        <div class="prem-section-header" @click="toggleSection('accesos')">
          <div class="d-flex align-items-center gap-2">
            <span class="prem-icon">🔗</span>
            <span class="prem-title">Accesos de Tipsters</span>
            <span class="prem-count">{{ prem.accesos.length }}</span>
          </div>
          <span class="toggle-icon">{{ sections.accesos ? '▲' : '▼' }}</span>
        </div>
        <div v-if="sections.accesos" class="table-responsive px-3 pb-3">
          <div v-if="prem.loading" class="text-center py-4 opacity-6"><div class="spinner-border spinner-border-sm text-primary me-2"></div></div>
          <table v-else class="table table-empirulada">
            <thead><tr>
              <th>Tipster</th><th>Telegram</th><th>Validado</th><th>Último acceso</th><th>Último start</th>
            </tr></thead>
            <tbody class="text-sm">
              <tr v-if="prem.accesos.length === 0"><td colspan="5" class="text-center py-4 opacity-6">Sin registros.</td></tr>
              <tr v-for="a in prem.accesos" :key="a.id">
                <td><strong>{{ a.tipster_nombre }}</strong></td>
                <td>
                  <span class="font-mono text-xs">@{{ a.telegram_username || '—' }}</span>
                  <span class="entidad-id ms-1">#{{ a.telegram_user_id }}</span>
                </td>
                <td>
                  <span class="badge-accion" :class="a.validado ? 'accion-crear' : 'accion-eliminar'">
                    {{ a.validado ? 'Sí' : 'No' }}
                  </span>
                </td>
                <td class="col-fecha-sm">{{ fmtFechaHora(a.ultimo_acceso_at) }}</td>
                <td class="col-fecha-sm">{{ fmtFechaHora(a.ultimo_start_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ── SESIONES DEL ASISTENTE ── -->
      <div class="card prem-section mb-4">
        <div class="prem-section-header" @click="toggleSection('sesiones')">
          <div class="d-flex align-items-center gap-2">
            <span class="prem-icon">💬</span>
            <span class="prem-title">Sesiones del Asistente</span>
            <span class="prem-count">{{ prem.sesiones.length }}</span>
          </div>
          <span class="toggle-icon">{{ sections.sesiones ? '▲' : '▼' }}</span>
        </div>
        <div v-if="sections.sesiones" class="table-responsive px-3 pb-3">
          <div v-if="prem.loading" class="text-center py-4 opacity-6"><div class="spinner-border spinner-border-sm text-primary me-2"></div></div>
          <table v-else class="table table-empirulada">
            <thead><tr>
              <th>Tipster</th><th>Telegram</th><th>Flujo</th><th>Paso actual</th><th>Último input</th>
            </tr></thead>
            <tbody class="text-sm">
              <tr v-if="prem.sesiones.length === 0"><td colspan="5" class="text-center py-4 opacity-6">Sin sesiones.</td></tr>
              <tr v-for="s in prem.sesiones" :key="s.id">
                <td><strong>{{ s.tipster_nombre }}</strong></td>
                <td>
                  <span class="font-mono text-xs">@{{ s.telegram_username || '—' }}</span>
                  <span class="entidad-id ms-1">#{{ s.telegram_user_id }}</span>
                </td>
                <td>
                  <span class="badge-accion" :class="s.flujo === 'idle' ? 'accion-otro' : 'accion-crear'">
                    {{ s.flujo || 'idle' }}
                  </span>
                </td>
                <td class="text-xs opacity-8">{{ s.paso_actual || '—' }}</td>
                <td class="col-fecha-sm">{{ fmtFechaHora(s.ultimo_input_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ── CANALES PREMIUM ── -->
      <div class="card prem-section mb-4">
        <div class="prem-section-header" @click="toggleSection('canales')">
          <div class="d-flex align-items-center gap-2">
            <span class="prem-icon">📡</span>
            <span class="prem-title">Canales Premium</span>
            <span class="prem-count">{{ prem.canales.length }}</span>
          </div>
          <span class="toggle-icon">{{ sections.canales ? '▲' : '▼' }}</span>
        </div>
        <div v-if="sections.canales" class="table-responsive px-3 pb-3">
          <div v-if="prem.loading" class="text-center py-4 opacity-6"><div class="spinner-border spinner-border-sm text-primary me-2"></div></div>
          <table v-else class="table table-empirulada">
            <thead><tr>
              <th>Canal</th><th>Tipster</th><th>Tipo</th><th>Validado</th><th>Bot admin</th><th>Tipster admin</th><th>Creado</th>
            </tr></thead>
            <tbody class="text-sm">
              <tr v-if="prem.canales.length === 0"><td colspan="7" class="text-center py-4 opacity-6">Sin canales premium.</td></tr>
              <tr v-for="c in prem.canales" :key="c.id">
                <td>
                  <strong>{{ c.canal_nombre }}</strong>
                  <span class="entidad-id d-block">#{{ c.telegram_chat_id }}</span>
                </td>
                <td>{{ c.tipster_nombre }}</td>
                <td>
                  <span class="badge-modulo" :class="claseCanal(c.tipo_canal)">{{ c.tipo_canal }}</span>
                </td>
                <td><span class="badge-accion" :class="c.canal_validado ? 'accion-crear' : 'accion-eliminar'">{{ c.canal_validado ? 'Sí' : 'No' }}</span></td>
                <td><span class="badge-accion" :class="c.bot_principal_admin ? 'accion-crear' : 'accion-otro'">{{ c.bot_principal_admin ? 'Sí' : 'No' }}</span></td>
                <td><span class="badge-accion" :class="c.tipster_admin ? 'accion-crear' : 'accion-otro'">{{ c.tipster_admin ? 'Sí' : 'No' }}</span></td>
                <td class="col-fecha-sm">{{ fmtFechaHora(c.created_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ── SOLICITUDES DE ENLACE ── -->
      <div class="card prem-section mb-4">
        <div class="prem-section-header" @click="toggleSection('links')">
          <div class="d-flex align-items-center gap-2">
            <span class="prem-icon">📧</span>
            <span class="prem-title">Solicitudes de Enlace</span>
            <span class="prem-count">{{ prem.links.length }}</span>
          </div>
          <span class="toggle-icon">{{ sections.links ? '▲' : '▼' }}</span>
        </div>
        <div v-if="sections.links" class="table-responsive px-3 pb-3">
          <div v-if="prem.loading" class="text-center py-4 opacity-6"><div class="spinner-border spinner-border-sm text-primary me-2"></div></div>
          <table v-else class="table table-empirulada">
            <thead><tr>
              <th>Tipster</th><th>Telegram</th><th>Estado</th><th>Email enviado</th><th>Expira</th><th>Usado</th>
            </tr></thead>
            <tbody class="text-sm">
              <tr v-if="prem.links.length === 0"><td colspan="6" class="text-center py-4 opacity-6">Sin solicitudes.</td></tr>
              <tr v-for="l in prem.links" :key="l.id">
                <td><strong>{{ l.tipster_nombre }}</strong></td>
                <td>
                  <span v-if="l.telegram_username" class="font-mono text-xs">@{{ l.telegram_username }}</span>
                  <span v-else class="opacity-5">—</span>
                </td>
                <td><span class="badge-accion" :class="claseEstadoLink(l.estado)">{{ l.estado }}</span></td>
                <td class="col-fecha-sm">{{ fmtFechaHora(l.email_enviado_at) }}</td>
                <td class="col-fecha-sm">{{ fmtFechaHora(l.expires_at) }}</td>
                <td class="col-fecha-sm">{{ fmtFechaHora(l.used_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </template>

  </div>
</template>

<script>
import botService from "@/services/bot.service.js";

export default {
  name: "RegistroMovimientos",

  data() {
    return {
      tabActiva: "sistema",

      // ── Tab Sistema ──
      sis: {
        loading: false,
        items: [],
        total: 0,
        paginas: 1,
        pagina: 1,
        modulos: [],
        acciones: [],
        sortColumn: "created_at",
        sortDirection: "desc",
        filtros: { q: "", modulo: "", accion: "", desde: "", hasta: "", porPagina: 50 },
      },

      // ── Tab Bot Básico ──
      bot: {
        loading: false,
        error: null,
        items: [],
        total: 0,
        paginas: 1,
        pagina: 1,
        canales: [],
        sortColumn: "fecha",
        sortDirection: "desc",
        filtros: { q: "", canal_id: "", accion: "", desde: "", hasta: "", porPagina: 50 },
      },

      // ── Tab Bot Premium ──
      prem: {
        loading: false,
        accesos: [],
        sesiones: [],
        links: [],
        canales: [],
      },

      // ── Log TDLib ──
      log: {
        loading: false,
        lineas: [],
        nLineas: 200,
        existe: false,
        totalKb: 0,
      },

      // Secciones colapsables premium
      sections: {
        log: true,
        accesos: true,
        sesiones: false,
        canales: true,
        links: false,
      },
    };
  },

  computed: {
    sisPaginasVisibles() { return this.calcPaginas(this.sis.paginas, this.sis.pagina); },
    botPaginasVisibles() { return this.calcPaginas(this.bot.paginas, this.bot.pagina); },
  },

  methods: {
    // ─── Tab switching ───────────────────────────────────────────────────────
    cambiarTab(tab) {
      this.tabActiva = tab;
      if (tab === 'premium' && this.prem.accesos.length === 0) {
        this.cargarPremium();
        this.cargarLog();
      }
    },

    toggleSection(key) { this.sections[key] = !this.sections[key]; },

    // ─── Tab Sistema ─────────────────────────────────────────────────────────
    async sisCargar(pagina = 1) {
      this.sis.loading = true;
      this.sis.pagina = pagina;
      try {
        const resp = await this.$store.dispatch("auth/listarMovimientos", {
          ...this.sis.filtros,
          paginaActual:  this.sis.pagina,
          sortColumn:    this.sis.sortColumn,
          sortDirection: this.sis.sortDirection,
        });
        if (resp?.res === "OK") {
          this.sis.items   = resp.items   || [];
          this.sis.total   = resp.total   || 0;
          this.sis.paginas = resp.paginas || 1;
          if (resp.modulos?.length)  this.sis.modulos  = resp.modulos;
          if (resp.acciones?.length) this.sis.acciones = resp.acciones;
        }
      } catch { /* silencioso */ } finally { this.sis.loading = false; }
    },

    sisLimpiar() {
      this.sis.filtros = { q: "", modulo: "", accion: "", desde: "", hasta: "", porPagina: 50 };
      this.sis.sortColumn = "created_at"; this.sis.sortDirection = "desc";
      this.sisCargar(1);
    },

    sisOrdenar(col) {
      this.sis.sortDirection = this.sis.sortColumn === col && this.sis.sortDirection === 'asc' ? 'desc' : 'asc';
      if (this.sis.sortColumn !== col) { this.sis.sortColumn = col; this.sis.sortDirection = 'desc'; }
      this.sisCargar(1);
    },

    sisSortIcon(col) {
      if (this.sis.sortColumn !== col) return "⇅";
      return this.sis.sortDirection === "asc" ? "↑" : "↓";
    },

    // ─── Tab Bot Básico ──────────────────────────────────────────────────────
    async botCargar(pagina = 1) {
      this.bot.loading = true;
      this.bot.error   = null;
      this.bot.pagina  = pagina;
      try {
        const resp = await botService.basico({
          ...this.bot.filtros,
          paginaActual:  this.bot.pagina,
          sortColumn:    this.bot.sortColumn,
          sortDirection: this.bot.sortDirection,
        });
        if (resp?.res === "OK") {
          this.bot.items   = resp.items   || [];
          this.bot.total   = resp.total   || 0;
          this.bot.paginas = resp.paginas || 1;
          if (resp.canales?.length) this.bot.canales = resp.canales;
        } else {
          this.bot.error = "La API devolvió una respuesta inesperada: " + JSON.stringify(resp);
        }
      } catch (e) {
        const status = e?.response?.status;
        this.bot.error = status
          ? `Error HTTP ${status}: ${e?.response?.data?.message || e.message}`
          : `Error de red: ${e?.message || 'desconocido'}`;
        console.error("[BotBasico] ERROR:", this.bot.error, e);
      } finally { this.bot.loading = false; }
    },

    botLimpiar() {
      this.bot.filtros = { q: "", canal_id: "", accion: "", desde: "", hasta: "", porPagina: 50 };
      this.bot.sortColumn = "fecha"; this.bot.sortDirection = "desc";
      this.botCargar(1);
    },

    botOrdenar(col) {
      this.bot.sortDirection = this.bot.sortColumn === col && this.bot.sortDirection === 'asc' ? 'desc' : 'asc';
      if (this.bot.sortColumn !== col) { this.bot.sortColumn = col; this.bot.sortDirection = 'desc'; }
      this.botCargar(1);
    },

    botSortIcon(col) {
      if (this.bot.sortColumn !== col) return "⇅";
      return this.bot.sortDirection === "asc" ? "↑" : "↓";
    },

    // ─── Tab Bot Premium ─────────────────────────────────────────────────────
    async cargarPremium() {
      this.prem.loading = true;
      try {
        const resp = await botService.premium();
        if (resp?.res === "OK") {
          this.prem.accesos  = resp.accesos  || [];
          this.prem.sesiones = resp.sesiones || [];
          this.prem.links    = resp.links    || [];
          this.prem.canales  = resp.canales  || [];
        }
      } catch { /* silencioso */ } finally { this.prem.loading = false; }
    },

    async cargarLog() {
      this.log.loading = true;
      try {
        const resp = await botService.log({ lineas: this.log.nLineas });
        if (resp?.res === "OK") {
          this.log.lineas   = resp.lineas   || [];
          this.log.existe   = resp.existe   || false;
          this.log.totalKb  = resp.total_kb || 0;
        }
      } catch { /* silencioso */ } finally { this.log.loading = false; }
    },

    // ─── Extra parsing (Bot Básico) ──────────────────────────────────────────
    parsedExtra(item) {
      const extra = item.extra || '';
      try {
        const obj = JSON.parse(extra);
        return { telegramId: obj.telegram_id || null, nombre: obj.nombre || null };
      } catch {
        if (extra.includes('##')) {
          const [id, nombre] = extra.split('##');
          return { telegramId: id, nombre };
        }
      }
      return { telegramId: null, nombre: null };
    },

    resumenExtra(item) {
      const extra = item.extra || '';
      if (!extra) return '—';
      try {
        const obj = JSON.parse(extra);
        const partes = [];
        if (obj.invite_link) partes.push(obj.invite_link.replace('https://t.me/', 't.me/'));
        if (obj.pedido_id)   partes.push(`Pedido #${obj.pedido_id}`);
        if (obj.campana_id && obj.campana_id > 0) partes.push(`Campaña #${obj.campana_id}`);
        if (obj.tipo)        partes.push(obj.tipo);
        return partes.join(' · ') || extra.slice(0, 60);
      } catch {
        return extra.slice(0, 60);
      }
    },

    // ─── Helpers comunes ─────────────────────────────────────────────────────
    calcPaginas(total, actual) {
      if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
      const pages = [1];
      if (actual > 3) pages.push("...");
      for (let p = Math.max(2, actual - 1); p <= Math.min(total - 1, actual + 1); p++) pages.push(p);
      if (actual < total - 2) pages.push("...");
      pages.push(total);
      return pages;
    },

    fmtFecha(dt) {
      if (!dt) return "—";
      return new Date(dt).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
    },
    fmtHora(dt) {
      if (!dt) return "";
      return new Date(dt).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
    },
    fmtFechaHora(dt) {
      if (!dt) return "—";
      const d = new Date(dt);
      return d.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" }) + ' ' +
             d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
    },

    iniciales(nombre) {
      if (!nombre) return "?";
      return nombre.split(/[\s._-]/).map(p => p[0]).join("").toUpperCase().slice(0, 2);
    },

    // ─── Clases CSS ──────────────────────────────────────────────────────────
    claseAccion(accion) {
      const mapa = { crear: "accion-crear", crear_ok: "accion-crear", editar: "accion-editar", actualizar: "accion-editar", eliminar: "accion-eliminar", borrar: "accion-eliminar", login: "accion-login", logout: "accion-logout", exportar: "accion-exportar", error: "accion-error", ver: "accion-ver", acceso: "accion-login" };
      return mapa[(accion || "").toLowerCase()] || "accion-otro";
    },

    claseAccionBot(accion) {
      const mapa = { A: "accion-crear", I: "accion-crear", F: "accion-exportar", D: "accion-eliminar", T: "accion-otro", B: "accion-login" };
      return mapa[accion] || "accion-otro";
    },

    descripcionAccionBot(accion) {
      const mapa = { A: "Aprobado", I: "Init canal", F: "Solicitud libre", D: "Denegado", T: "Texto", B: "Grupo" };
      return mapa[accion] || accion;
    },

    claseModulo(modulo) {
      const mapa = { "Usuarios": "mod-usuarios", "Tipsters": "mod-tipsters", "Canales": "mod-canales", "Campañas": "mod-campanas", "Servicios": "mod-servicios", "Pedidos": "mod-pedidos", "Descuentos": "mod-descuentos", "Devoluciones": "mod-devoluciones", "Pasarelas": "mod-pasarelas", "Roles": "mod-roles", "Configuración": "mod-config", "Auth": "mod-auth" };
      return mapa[modulo] || "mod-otro";
    },

    claseNivelLog(nivel) {
      const mapa = { ERROR: "log-error", WARNING: "log-warning", INFO: "log-info", DEBUG: "log-debug" };
      return mapa[nivel] || "";
    },

    claseCanal(tipo) {
      const mapa = { premium: "mod-canales", origen: "mod-tipsters", traduccion: "mod-servicios", soporte: "mod-config" };
      return mapa[tipo] || "mod-otro";
    },

    claseEstadoLink(estado) {
      const mapa = { pendiente: "accion-exportar", usado: "accion-crear", expirado: "accion-eliminar", cancelado: "accion-otro" };
      return mapa[estado] || "accion-otro";
    },
  },

  async mounted() {
    this.$store.commit('setShowFooter', true);
    this.sisCargar(1);
    this.botCargar(1);
  },
};
</script>

<style scoped>
.container-fluid { max-width: 1300px; }

/* ══ TAB BAR ══ */
.tabs-bar {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.tab-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 22px;
  border: 2px solid var(--q-border);
  border-radius: 10px;
  background: var(--q-card);
  color: var(--q-muted);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: .15s ease;
  letter-spacing: .3px;
}
.tab-btn:hover { border-color: var(--q-border-md); color: var(--q-text); background: var(--q-hover); }
.tab-btn--activo {
  border-color: var(--q-gold);
  background: rgba(245,166,35,.08);
  color: var(--q-gold);
}
.tab-icon { font-size: 15px; }

/* ══ FILTROS ══ */
.filtros-grid { display: flex; flex-wrap: wrap; gap: 12px; align-items: flex-end; }
.filtro-item { display: flex; flex-direction: column; gap: 4px; min-width: 140px; }
.filtro-q    { min-width: 220px; flex: 1 1 220px; }
.filtro-btns { flex-direction: row; gap: 8px; align-items: flex-end; min-width: unset; }
.filtro-label { font-size: 11px; font-weight: 600; color: var(--q-muted); text-transform: uppercase; letter-spacing: .4px; }

.filtro-item .form-control,
.filtro-item select.form-control,
select.form-control {
  background-color: var(--q-card-alt);
  color: var(--q-text);
  border: 1px solid var(--q-border-md);
  border-radius: 8px;
}
.filtro-item .form-control:focus,
.filtro-item select.form-control:focus {
  background-color: var(--q-card-alt);
  color: var(--q-text);
  border-color: var(--q-gold);
  box-shadow: 0 0 0 2px rgba(245,166,35,.15);
}
.filtro-item input[type="date"] { color-scheme: dark; }

@media (max-width: 600px) {
  .filtro-item { min-width: 100%; }
  .filtro-btns { width: 100%; }
}
@media (max-width: 480px) {
  .filtros-grid { width: 100%; }
  .tabs-bar { gap: 6px; }
  .tab-btn { padding: 8px 14px; font-size: 12px; }
}

/* ══ TABLA EMPIRULADA ══ */
.table-empirulada { border-collapse: separate !important; border-spacing: 0 6px; min-width: 700px; }
.table-empirulada thead th { border: 0 !important; background: var(--q-hover); color: var(--q-text); font-weight: 700; font-size: 11px; text-transform: uppercase; letter-spacing: .5px; padding: 10px 12px; white-space: nowrap; }
.table-empirulada tbody tr { background: var(--q-card); box-shadow: 0 2px 8px rgba(0,0,0,.3); transition: transform .12s, box-shadow .12s; }
.table-empirulada tbody tr:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(0,0,0,.4); }
.table-empirulada tbody td { border: 0 !important; padding: 10px 12px; vertical-align: middle; }
.table-empirulada tbody tr td:first-child { border-top-left-radius: 10px; border-bottom-left-radius: 10px; }
.table-empirulada tbody tr td:last-child  { border-top-right-radius: 10px; border-bottom-right-radius: 10px; }
.table-empirulada > :not(caption) > * > * { border-bottom-width: 0 !important; }
.table-empirulada thead tr { box-shadow: none !important; background: transparent !important; }

.col-fecha     { min-width: 100px; }
.col-fecha-sm  { min-width: 110px; font-size: 11px; color: var(--q-muted); font-family: var(--q-font-mono); font-variant-numeric: tabular-nums; }
.col-descripcion { max-width: 220px; }
.col-descripcion span,
.col-descripcion { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 220px; cursor: help; }
.col-ip        { font-family: var(--q-font-mono); font-size: 11px; color: var(--q-muted); }

.th-sort { cursor: pointer; user-select: none; }
.th-sort:hover { background: var(--q-border) !important; }
.sort-icon { font-size: 11px; margin-left: 4px; opacity: .6; }

/* ══ FECHA / USUARIO ══ */
.fecha-bloque { display: flex; flex-direction: column; gap: 1px; }
.fecha-dia    { font-weight: 700; font-size: 12px; color: var(--q-text); font-family: var(--q-font-mono); font-variant-numeric: tabular-nums; }
.fecha-hora   { font-size: 11px; color: var(--q-muted); font-family: var(--q-font-mono); font-variant-numeric: tabular-nums; }
.usuario-bloque { display: flex; align-items: center; gap: 8px; }
.usuario-avatar { width: 28px; height: 28px; border-radius: 50%; background: var(--q-gold); color: var(--q-gold-on); font-size: 10px; font-weight: 700; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }

/* ══ BADGES ══ */
.badge-accion { display: inline-block; padding: 3px 10px; border-radius: 20px; font-size: 11px; font-weight: 700; white-space: nowrap; }
.accion-crear    { background: var(--q-green-soft); color: var(--q-green); }
.accion-editar   { background: var(--q-hover); color: var(--q-muted); }
.accion-eliminar { background: var(--q-red-soft); color: var(--q-red); }
.accion-login    { background: var(--q-hover); color: var(--q-muted); }
.accion-logout   { background: var(--q-red-soft); color: var(--q-red); }
.accion-exportar { background: var(--q-amber-soft); color: var(--q-amber); }
.accion-error    { background: var(--q-red-soft); color: var(--q-red); }
.accion-ver      { background: var(--q-green-soft); color: var(--q-green); }
.accion-otro     { background: var(--q-hover); color: var(--q-muted); }

.badge-modulo { display: inline-block; padding: 2px 9px; border-radius: 6px; font-size: 11px; font-weight: 600; white-space: nowrap; }
.mod-usuarios  { background: var(--q-hover); color: var(--q-muted); }
.mod-tipsters  { background: var(--q-hover); color: var(--q-muted); }
.mod-canales   { background: var(--q-green-soft); color: var(--q-green); }
.mod-campanas  { background: var(--q-red-soft); color: var(--q-red); }
.mod-servicios { background: var(--q-hover); color: var(--q-muted); }
.mod-pedidos   { background: var(--q-amber-soft); color: var(--q-amber); }
.mod-descuentos{ background: var(--q-amber-soft); color: var(--q-amber); }
.mod-devoluciones{ background: var(--q-red-soft); color: var(--q-red); }
.mod-pasarelas { background: var(--q-green-soft); color: var(--q-green); }
.mod-roles     { background: var(--q-hover); color: var(--q-muted); }
.mod-config    { background: var(--q-hover); color: var(--q-muted); }
.mod-auth      { background: var(--q-hover); color: var(--q-muted); }
.mod-otro      { background: var(--q-hover); color: var(--q-muted); }

.entidad-chip  { display: inline-flex; align-items: center; gap: 3px; background: var(--q-hover); border-radius: 6px; padding: 2px 8px; font-size: 11px; color: var(--q-muted); }
.entidad-id    { opacity: .65; font-size: 10px; }
.ip-text       { font-family: var(--q-font-mono); font-size: 11px; }
.font-mono     { font-family: var(--q-font-mono); }

/* ══ PAGINACIÓN ══ */
.paginacion { display: flex; gap: 4px; align-items: center; justify-content: center; flex-wrap: wrap; }
.pag-btn { min-width: 36px; height: 34px; border: 1px solid var(--q-border); border-radius: 8px; background: var(--q-card); color: var(--q-text); font-size: 13px; font-weight: 600; cursor: pointer; transition: .15s ease; padding: 0 10px; }
.pag-btn:hover:not(:disabled) { background: var(--q-hover); border-color: var(--q-border-md); }
.pag-btn:disabled { opacity: .4; cursor: default; }
.pag-btn--activo  { background: var(--q-gold) !important; color: var(--q-gold-on) !important; border-color: var(--q-gold) !important; }
.pag-dots { padding: 0 6px; color: var(--q-muted); font-size: 14px; }

/* ══ BOT PREMIUM ══ */
.stats-row { display: flex; gap: 12px; flex-wrap: wrap; }
.stat-card { flex: 1 1 140px; background: var(--q-card); border: 1px solid var(--q-border); border-radius: 12px; padding: 16px 20px; display: flex; flex-direction: column; gap: 4px; }
.stat-num  { font-size: 28px; font-weight: 800; color: var(--q-gold); font-variant-numeric: tabular-nums; }
.stat-label { font-size: 11px; color: var(--q-muted); text-transform: uppercase; letter-spacing: .4px; font-weight: 600; }

.prem-section { overflow: hidden; }
.prem-section-header { display: flex; align-items: center; justify-content: space-between; padding: 16px 20px; cursor: pointer; transition: background .15s; user-select: none; }
.prem-section-header:hover { background: var(--q-hover); }
.prem-title { font-weight: 700; font-size: 14px; color: var(--q-text); }
.prem-icon  { font-size: 16px; }
.prem-count { display: inline-flex; align-items: center; justify-content: center; min-width: 22px; height: 22px; border-radius: 50%; background: var(--q-hover); color: var(--q-muted); font-size: 11px; font-weight: 700; padding: 0 6px; }
.toggle-icon { font-size: 11px; color: var(--q-muted); }

/* ══ LOG VIEWER ══ */
.log-viewer {
  background: #060b10;
  border-top: 1px solid var(--q-border);
  font-family: var(--q-font-mono, monospace);
  font-size: 11.5px;
  line-height: 1.6;
  max-height: 540px;
  overflow-y: auto;
  padding: 12px 16px;
}
.log-linea { display: flex; gap: 8px; padding: 1px 0; flex-wrap: wrap; }
.log-ts    { color: #4a6080; white-space: nowrap; flex-shrink: 0; }
.log-nivel { font-weight: 700; white-space: nowrap; flex-shrink: 0; min-width: 60px; }
.log-msg   { color: #8da4bc; word-break: break-all; }

.log-nivel--info     { color: #4a90a4; }
.log-nivel--warning  { color: var(--q-amber); }
.log-nivel--error    { color: var(--q-red); }
.log-nivel--debug    { color: #4a6080; }
.log-nivel--raw      { color: #4a6080; }
.log-nivel--critical { color: var(--q-red); }

.log-error   .log-msg { color: #c97070; }
.log-warning .log-msg { color: #b89050; }
.log-info    .log-msg { color: #8da4bc; }

@media (max-width: 600px) {
  .stats-row { flex-direction: column; }
  .stat-card { flex: unset; }
  .prem-section-header { padding: 12px 14px; }
}
</style>
